export default "__VITE_ASSET__IXtxwMfC__"